<template>
    <div class="app-content">
      <AppPageTitle></AppPageTitle>
      <Content class="app-content__main">
        <Row>
          <Col :md='24' style="margin-bottom: 20px">
            <Button
              type="primary"
              icon="md-add"
              style="margin-right: 8px"
              @click="createItem"
            >新增</Button>
          </Col>
      </Row>
        <Table
          :columns="queryColumn"
          :loading="loading"
          :data="queryData"
          border
          ref="dataTable"
        >
          <template slot-scope="{row}" slot="useState">
            <Tag color="cyan" v-if="row.useState">已激活</Tag>
            <Tag color="red" v-else>已暂停</Tag>
          </template>
          <template slot-scope="{row}" slot="action">
            <Button
              v-if="row.useState"
              type="text"
              class="text-link"
              size="small"
              icon="md-pause"
              @click="statusItem(row)"
            >暂停</Button>
            <Button
              v-else
              type="text"
              class="text-link"
              size="small"
              icon="md-play"
              @click="statusItem(row)"
            >激活</Button>
          </template>
        </Table>
        <Row>
          <Col :md="24" class="pagination">
            <Page
              :total="totalPage"
              :page-size="pageSize"
              :current="pageNum"
              :disabled="loading"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              show-elevator show-sizer show-total />
          </Col>
        </Row>
      </Content>
      <AddBox ref="agentApiCreateUpdate" @success="createUpdateSuccess"></AddBox>
    </div>
  </template>

<script>
import api from '@/api'
import AddBox from './Add.vue'

export default {
  components: {
    AddBox
  },
  data () {
    return {
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    queryColumn () {
      return [
        {
          title: '代理商编号',
          key: 'agentId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '代理商名称',
          key: 'agentName',
          align: 'center',
          minWidth: 120
        },
        {
          title: '接口名称',
          key: 'reqName',
          align: 'center',
          minWidth: 120
        },
        {
          title: '接口地址',
          key: 'reqUrl',
          align: 'center',
          minWidth: 200
        },
        {
          title: '激活状态',
          key: 'useState',
          minWidth: 100,
          slot: 'useState',
          align: 'center'
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 120,
          slot: 'action',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    getData () {
      this.loading = true
      api.agent.agentPermissionsList({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取代理商接口权限列表失败: ' + err.message)
        })
    },
    // 新增
    createItem () {
      this.$refs.agentApiCreateUpdate.show('create')
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 暂停/激活
    statusItem (row) {
      const stateText = row.useState ? '暂停' : '激活'
      this.$Modal.confirm({
        title: stateText + '确认',
        content: `<p>您确定${stateText}此代理商接口的授权状态吗？</p>
                    <p><small class="text-danger">注：${stateText}后，代理商接口的所有代理请求将会被${row.useState ? '拒绝' : '允许'}。</small></p>`,
        loading: true,
        onOk: () => {
          api.agent.agentPermissionsUpdateState({
            id: row.id,
            agentId: row.agentId,
            agentName: row.agentName,
            reqUrl: row.reqUrl,
            useState: row.useState ? 0 : 1,
            reqName: row.reqName
          })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.$Message.success(`${stateText}成功!`)
            })
            .catch((err) => {
              this.$Modal.remove()
              this.$Modal.error({
                title: '抱歉',
                content: `${stateText}失败: ` + err.message
              })
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
    }
  },
  created () {
    this.getData()
  }
}
</script>
